<template>
  <div :class="{'item-error': item.error}">
    <b-card class="item-card">
      <options :item="item" :level="level"/>

      <h2 class="item-title">Image</h2>

      <b-container fluid>
        <b-row>
          <b-col cols="12" lg="6" xl="3">
            <image-preview
              :src="previewSrc"
              @click.native="displayMedia(true)"/>
          </b-col>

          <b-col cols="9" lg="6" xl="3" class="mt-2 mt-lg-0">
            <b-form-group>
              <b-button
                :disabled="saving || fetching"
                @click="showMediaLibrary()">
                Browse Library
              </b-button>
            </b-form-group>

            <span class="name">Name:</span>
            <span v-if="selectedMedia">
              {{ selectedMedia.name }}
            </span>
            <br>
            <span class="name">Size:</span>
            <span v-if="selectedMedia">
              {{ readableFilesize(selectedMedia.size) }}
            </span>
            <br>
            <span class="name">Created:</span>
            <span v-if="selectedMedia">
              {{ readableDate(selectedMediaCreatedDate) }}
            </span>
            <validation-errors :validation-errors="item.apiErrors"/>
          </b-col>

          <b-col cols="12" lg="8" xl="4" class="mt-2 mt-xl-0">
            <b-form v-if="formShow" @submit="onSubmit">
              <p> Upload a new file </p>
              <b-form-group>
                <b-form-input
                  v-validate="'required'"
                  id="name-input"
                  :disabled="fetching || saving || item.form.saving"
                  :class="{ 'is-invalid' : errors.has('name') }"
                  :value="item.form.fields.name"
                  class="form-control"
                  placeholder="name"
                  type="text"
                  name="name"
                  @input="setName"/>
                <validation-errors :validation-errors="[errors.first('name')]"/>
                <validation-errors v-if="!errors.has('name')" :validation-errors="item.form.apiErrors.name"/>
              </b-form-group>

              <b-form-group>
                <image-upload
                  @fileForEdit="setFile"
                  @cropImage="setCropImage"
                  @name="setName"
                  @imageUploadHasError="setImageUploadHasError"
                />
              </b-form-group>

              <b-form-group>
                <b-button :disabled="submitDisabled" type="submit" variant="primary">
                  Upload
                  <span v-if="item.form.saving"><i class="fas fa-spinner fa-spin"></i></span>
                </b-button>
              </b-form-group>

              <form-success :success="item.form.success" class="form-alert">Media Uploaded!</form-success>
            </b-form>
          </b-col>
        </b-row>
      </b-container>

    </b-card>

    <b-modal
      v-model="mediaLibraryVisible"
      title="Media Library"
      centered hide-footer
      size="lg">
      <media-table
        v-if="mediaLibrary.visible"
        :view="mediaView"
        :show-type-select="false"
        :module-id="module.id"
        :ids-to-highlight="idsToHighlight"
        context="selectOne"
        type="image"
        @selectMedia="setMediaID"/>
    </b-modal>

    <b-modal v-model="showMediaModal"
             :title="name"
             centered 
             hide-footer
             size="lg">
      <b-img :src="url" />
    </b-modal>

  </div>
</template>

<script>
import mediaMixin from '../../mixins/media-item'
import options from './options'
import imagePreview from '../../../common/image-preview'
import imageUpload from '../../../common/form/image-upload'
import mediaTable from '../media/table'
import formSuccess from '../../../common/form/form-success'
import formWrapper from '../../../common/form/form-wrapper'
import validationErrors from '../../../common/form/validation-errors'

export default {
  components: {
    options,
    formSuccess,
    formWrapper,
    imagePreview,
    imageUpload,
    mediaTable,
    validationErrors
  },
  mixins: [mediaMixin],
  data () {
    return {
      imageUploadHasError: false,
      cropImage: false,
      mediaLibraryVisible: false
    }
  },
  computed: {
    previewSrc () {
      if (this.selectedMedia && this.selectedMedia.thumbnail) {
        return this.selectedMedia.thumbnail.url
      } else if (this.selectedMedia) {
        return this.selectedMedia.url
      } else {
        return ''
      }
    },
    selectedMediaName () {
      if (this.selectedMedia && this.selectedMedia.name)
      {
        return this.selectedMedia.name
      } else {
        return ''
      }
    },
    selectedMediaThumbnail () {
      if (this.thumbnail)
      {
        return this.thumbnail
      } else {
        return ''
      }
    },
    selectedMediaCreatedDate () {
      if (this.selectedMedia && this.selectedMedia.created_at) {
        return this.selectedMedia.created_at
      } else {
        return ''
      }
    }
  },
  methods: {
    setImageUploadHasError(hasError) {
      this.imageUploadHasError = hasError
    },
    setCropImage (value) {
      this.cropImage = value
    },
    showMediaLibrary () {
      this.mediaLibraryVisible = true
      this.showLibraryModal()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/items/image.vue